import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { patientAllHistoryByObjId } from 'api/auth.api';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const usePatientAllListByObjId = (page, patientObjId) => {
  const toast = useToast();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['patientAllHistoryByObjId', page, patientObjId],

    queryFn: () =>
      patientAllHistoryByObjId({
        page,
        patientObjId,
      }),

    enabled: !!patientObjId,

    select: (res) => res?.data || {},

    onError: (error) => {
      toast({
        title: getErrorMessage(error, 'Failed to fetch patient history'),
        status: 'error',
      });
    },
  });

  return {
    patientHistory: data?.result || [],
    totalPages: data?.totalPages || 1,
    isLoading: isLoading || isFetching,
  };
};
